if(!customElements.get("booking-popup")) {
  customElements.define("booking-popup", 
    class BookingPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
    this.button = this.querySelector("button");
    this.button.addEventListener("click", this.handleClick.bind(this));

    this.bookingPopup = document.querySelector(".booking-popup");
    this.bookingPopupContainer = this.bookingPopup.querySelector(".booking-popup__container");
    this.bookingPopupClose = this.bookingPopup.querySelector(".booking-popup__close");

    this.bookingPopupClose.addEventListener("click", this.handleClose.bind(this));
    this.bookingPopup.addEventListener("click", this.handleClose.bind(this));

    this.button.addEventListener("click", this.handleOpen.bind(this));

    this.getForm = this.getForm.bind(this);
    this.isFormLoaded = false;

    // Auto-open popup if form was just submitted successfully
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('contact_posted')) {
      this.handleOpen();
    }
  }

  async getForm(){
    try {
        if(this.isFormLoaded) return;
        const hasContactPosted = new URLSearchParams(window.location.search).has('contact_posted');
        const baseUrl = hasContactPosted ? window.location.href : (this.dataset.productUrl || window.location.href);
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set("view", "product-form");
        const newUrl = url.toString();
        const response = await fetch(newUrl);
        const data = await response.text();
        const parsedHTML = new DOMParser().parseFromString(data, 'text/html');

        console.log(parsedHTML);

        const pcfElements = this.bookingPopupContainer.querySelectorAll('.pcf');
        pcfElements?.forEach(element => {
            element.remove();
        });

        const section = parsedHTML.querySelector('.pcf');
        if(section){
            this.bookingPopupContainer.appendChild(section);
            this.isFormLoaded = true;
        }
    } catch (error) {
        console.error(error);
        return null;
    }
  }

  handleClick(event) {
    event.preventDefault();
  }

  handleClose(event) {
    if(event.target.classList.contains("booking-popup__close") || event.target.classList.contains("booking-popup")
    || event.target.classList.contains("svg-icon--close")
    ){
    this.bookingPopup.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
    }
  }

  async handleOpen(event) {
    if (event) event.preventDefault();
    await this.getForm();
    this.bookingPopup.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
  }
  });
}